import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import file1 from '../assets/Pdf/Notice for Open House 28Feb 2025.pdf'
import file2 from '../assets/Pdf/OpenHouseOfficeMemorandum31JAN2025.pdf'
import file3 from '../assets/Pdf/digital RC OM.pdf'
import file4 from '../assets/Pdf/OM for Rationalization of FE Registration Process.pdf'
import file5 from '../assets/Pdf/Gazette-Notification-and-SoPs-for-introduction-of-Credit-Insurance-(CI)-to-provide-financial-security.pdf'
import file6 from '../assets/Pdf/Advisory for Beirut.png'

const circulars = [
    { date: "February 20th, 2025", title: "Notice for Open House 28Feb 2025", isnew: 1, file: file1 },
    { date: "January 28th, 2025", title: "Office Memorandum on Open House_January 2025", isnew: 1, file: file2 },
    { date: "January 17th, 2025", title: "Digital RC OM", isnew: 1, file: file3 },
    { date: "NOVEMBER 4th, 2024", title: "OM for Rationalization of FE Registration Process", isnew: 0, file: file4 },
    { date: "OCTOBER 4th, 2024", title: "Gazette Notification and SoPs for introduction of Credit Insurance (CI) to provide financial security as additional...", isnew: 0, file: file5 },
    { date: "OCTOBER 1st, 2024", title: "Advisory for Indian Nationals traveling to/residing in Lebanon", isnew: 0, file: file6 },
];

export default function LatestCirculars() {
    const [index, setIndex] = useState(0);
    const visibleItems = window.innerWidth < 768 ? 1 : 3; // Show 1 item on mobile and 3 items on desktop

    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % (circulars.length - visibleItems + 1));
    };

    const prevSlide = () => {
        setIndex((prev) => (prev - 1 + (circulars.length - visibleItems + 1)) % (circulars.length - visibleItems + 1));
    };
    const handleDownload = (file) => {
        const link = document.createElement('a');
        link.href = file;
        link.download = file.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            {/* Circulars Section */}
            <div className="text-center mb-8">
                <h2 className="text-4xl font-extrabold text-green-600">📄 Latest <span className="text-blue-900">Circulars</span></h2>
            </div>
            <div className="relative flex items-center justify-center overflow-hidden">
                <button onClick={prevSlide} aria-label="Previous circular" className="absolute left-0 p-1 bg-gray-300 rounded-full hover:bg-gray-300 z-10 transition-all duration-200 ease-in-out transform hover:scale-105">
                    <ChevronLeft size={24} />
                </button>
                <div className="flex space-x-6 overflow-x-auto w-full max-w-7xl">
                    {circulars.slice(index, index + visibleItems).map((circular, i) => (
                        <div
                            key={i}
                            className="relative p-4 border rounded-lg border-green-400 shadow-lg text-left bg-white w-full lg:w-1/3 transition-all duration-200 ease-in-out transform hover:shadow-xl hover:bg-green-50 cursor-pointer"
                            onClick={() => handleDownload(circular.file)}
                        >
                            {/* NEW label */}
                            {circular.isnew === 1 && (
                                <span className="absolute top-1 left-1 inline-block bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-full mb-2 z-20">
                                    NEW
                                </span>
                            )}
                            <h3 className="text-lg font-extrabold text-blue-950 mb-2 mt-3 pl-4">{circular.date}</h3>
                            <p className="text-gray-800 pl-4 " >{circular.title}</p>
                        </div>
                    ))}
                </div>
                <button onClick={nextSlide} aria-label="Next circular" className="absolute right-0 p-1 bg-gray-300 rounded-full hover:bg-gray-300 z-10 transition-all duration-200 ease-in-out transform hover:scale-105">
                    <ChevronRight size={24} />
                </button>
            </div>
        </div>
    );
}
